/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type PrebookingAlertResolveDialogAlertFragment = {
  __typename?: 'TripPrebookingNoAssignment'
  id: string
  status: Types.TaskNotificationStatus
  rejectionAt: string
  trip: {
    __typename?: 'Trip'
    id: string
    pickup: {
      __typename?: 'TripTransferInformation'
      promisedTime: {
        __typename?: 'DateTimeInterval'
        from: string
        to: string
      }
    }
    customer: {
      __typename?: 'Customer'
      firstName: string | null
      lastName: string | null
      phoneNumber: string | null
    } | null
    seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
  } | null
  pickupStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  dropoffStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
}

export const PrebookingAlertResolveDialogAlertFragmentDoc = gql`
    fragment PrebookingAlertResolveDialogAlert on TripPrebookingNoAssignment {
  id
  status
  rejectionAt
  trip {
    id
    pickup {
      promisedTime {
        from
        to
      }
    }
    customer {
      firstName
      lastName
      phoneNumber
    }
    seatInfo {
      wheelchairs
    }
  }
  pickupStop {
    id
    address {
      street
      houseNumber
      postalCode
      city
    }
    names
    routingLocation {
      latitude
      longitude
    }
  }
  dropoffStop {
    id
    address {
      street
      houseNumber
      postalCode
      city
    }
    names
    routingLocation {
      latitude
      longitude
    }
  }
}
    `
